import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import InputMask from "react-input-mask";
import moment from "moment";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Revert from "../common/Revert";

const DateInput = (props) => {
	const hasValue = !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const id = generateGuid();
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ?
		//<Tooltip isInput text={"Formaat: dd-mm-jjjj " + props.tooltip} tooltipType={tooltiptype} /> : null;
		<Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	let validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;

	const fromRange = (moment(props.fromRange, "DD-MM-YYYY"));
	const toRange = (moment(props.toRange, "DD-MM-YYYY"));
	const hasRange = (fromRange.isValid() && toRange.isValid());

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});

	let value = props.value ? props.value : "";
	if (typeof value === "string" && value.indexOf("T") !== -1) {
		value = moment(props.value).format("DD-MM-YYYY");
	} else if (moment.isMoment(value)) {
		value = value.format("DD-MM-YYYY");
	}

	const revertable = (props.originalValue !== undefined && props.value) ? props.originalValue !== value : false;

	let doParseBeforeOnChange = function (e) {
		let value = e.target.value;
		let dd = value.substring(0, 2);
		let mm = value.substring(3, 5);
		let yy = value.substring(6, 10);
		let date = yy + "-" + mm + "-" + dd + "T00:00";

		if (moment(date).isValid()) {
			if (hasRange) {
				if (moment(date).isSameOrAfter(fromRange) && moment(date).isSameOrBefore(toRange)) {
					e.target.value = date;
				} else {
					return;
				}
			} else {
				e.target.value = date;
			}
		}

		props.onChange(e);
	};

	return (
		<div className={sizeClassName}>
			<div className={containerClassName}>
				<InputMask
					id={id}
					mask="99-99-9999"
					value={value}
					disabled={props.disabled}
					onChange={doParseBeforeOnChange}
					className={inputClassName}
					name={props.name} />
				<label
					className={labelClassName}
					htmlFor={id}>
					{label}
				</label>
				{info}
				{!revertable || <Revert
					onChange={props.onChange}
					name={props.name}
					originalValue={props.originalValue} />}
			</div>
			{validation}
		</div>
	);
};

DateInput.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string
	]),
	originalValue: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.string
	]),
	disabled: PropTypes.bool,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	optional: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	fromRange: PropTypes.string,
	toRange: PropTypes.string
};

export default DateInput;
